import React, { useState } from "react";
import Div from "@jumbo/shared/Div";
import {
  CardContent,
  Typography,
  Button,
  Collapse,
  Alert,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { ROUTES } from "app/utils/constants/routeConstants";
import { useNavigate, useLocation } from "react-router-dom";
import { ASSET_CODINGPAL } from "app/utils/constants/paths";
import { ALERT_SEVERITIES } from "app/utils/constants/constants";

const VerifyAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);

  // Get email and source from navigation state
  const email = location.state?.email || "your email";
  const source = location.state?.source || "signup";

  const isFromForgotPassword = source === "forgotPassword";

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setError(null);
    setSuccess(null);
  };

  return (
    <Div
      sx={{
        width: 720,
        maxWidth: "100%",
        margin: "auto",
        p: 4,
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: "#f5f7fa",
        }}
      >
        <Div
          sx={{
            mb: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={`${ASSET_CODINGPAL}/verify-email.png`}
            alt="Email Sent"
            width={120}
            height={120}
            style={{ objectFit: "contain" }}
          />
          <Typography
            variant="h3"
            sx={{
              fontWeight: 500,
              mt: 2,
              mb: 2,
              color: "text.primary",
            }}
          >
            {isFromForgotPassword
              ? "Reset Your Password"
              : "Verify Your Account"}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: "text.secondary",
              maxWidth: 500,
            }}
          >
            An email has been sent to <strong>{email}</strong>. Please check
            your inbox (and spam/junk folder) to{" "}
            {isFromForgotPassword
              ? "proceed with resetting your password."
              : "verify your account."}
          </Typography>
        </Div>
        <Collapse in={openAlert}>
          <Alert
            severity={
              success ? ALERT_SEVERITIES.SUCCESS : ALERT_SEVERITIES.ERROR
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleCloseAlert}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2, width: "100%", maxWidth: 500 }}
          >
            {success || error}
          </Alert>
        </Collapse>
        <Div
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            width: "100%",
            maxWidth: 500,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="body1">Already verified?</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(ROUTES.USER_LOGIN)}
          >
            Login
          </Button>
        </Div>
      </CardContent>
    </Div>
  );
};

export default VerifyAccount;
